import { SeV2AnnouncementDto } from "../../../autogen/bff-api";

export interface PublishedDocument {
  id: string;
  name: string;
  uploadedAt: string;
}

// Documents the buyer published to all tenderers via an announcement ("Send til alle"). They live on the
// announcements rather than in the event's competition documents, so we surface them alongside the tender
// documents. Deduped by document id; anything already shown as a competition document is dropped so it isn't
// listed twice. The announcement's own timestamp is used as the document's date.
export const collectPublishedDocuments = (
  announcements: SeV2AnnouncementDto[],
  existingDocumentIds: Iterable<string>,
): PublishedDocument[] => {
  const excluded = new Set(existingDocumentIds);
  const seen = new Set<string>();
  const documents: PublishedDocument[] = [];
  for (const announcement of announcements) {
    for (const attachment of announcement.attachments ?? []) {
      const id = attachment.documentId;
      if (excluded.has(id) || seen.has(id)) continue;
      seen.add(id);
      documents.push({ id, name: attachment.fileName, uploadedAt: announcement.createdAt });
    }
  }
  return documents;
};
